import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormSelectOpcDataType from "../../../../../components/form/FormSelectOpcDataType";
// INTERFACES
import {
	AddItemInterface,
	DataRepresentationInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentWriteAddItem({
	data,
	setData,
}: {
	data: AddItemInterface;
	setData: (newValue: AddItemInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string, variableName: string) => {
		const copy = structuredClone(data);
		if (variableName === "name") {
			copy.item.name = newValue;
		} else if (variableName === "group_name") {
			copy.item.group_name = newValue;
		}
		setData(copy);
	};

	const setDataType = (newValue: DataRepresentationInterface) => {
		const copy = structuredClone(data);
		copy.item.data_type = newValue;
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.item.name}
				inputLabelName={t("general.name")}
				inputOnChange={onChangeValue}
				inputVariableName='name'
				isRequired
				disabledInput={false}
				
			/>
			<FormInputText
				inputValue={data.item.group_name}
				inputLabelName={t("general.groupName")}
				inputOnChange={onChangeValue}
				inputVariableName='group_name'
				isRequired
				disabledInput={false}
				
			/>
			<FormSelectOpcDataType
				inputValue={data.item.data_type}
				inputOnChange={setDataType}
				disabledInput={false}
			/>
		</div>
	);
}
